import React from "react";

const UnauthorizedPage = () => {
  return (
    <div>
      <h1>Unauthorized</h1>
      <p>You don't have permission to access this page.</p>
    </div>
  );
};

export default UnauthorizedPage;